<div style="height:100%; display: flex; align-items: flex-start; justify-content: center; font-size: 16px; padding-top: 140px;">
  <div>
    <div style="display: flex; flex-direction: column; justify-content: center;">
      <div style="width: 100%; display: flex; justify-content: center; padding: 15px 0;">
        <img *ngIf="!isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo.svg" alt="lexbe-logo">
        <img *ngIf="isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo-dark-theme-3.svg" alt="lexbe-logo">
      </div>
      <div style="padding: 36px 0; text-align: center; width: 400px; margin: auto;">
        <span class="fas fa-lock" style="padding-right: 15px;"></span><span style="font-weight: 500;">Two Step Verification</span>
        <div class="choose-method-prompt" style="font-size:14px; padding-top: 20px;">You've taken extra steps to protect your account. Please choose a method below to sign in.</div>
      </div>
      <div>
        <div style="display: flex; flex-direction: column; gap: 15px;">
          <button id="mfa-submit-code-email" *ngIf="authenticationService.supportedMfaProviders.includes('Email')" mat-raised-button [ngClass]="{'selected-mfa-method': mfaSelectedMethod === 'Email'}" (click)="sendCode('Email')">
            <div style="display: flex; align-items: center; padding: 25px 11px; gap: 15px; width: 450px;">
              <div *ngIf="!(isLoading && mfaSelectedMethod === 'Email')" class="fas fa-envelope"></div>
              <div *ngIf="!(isLoading && mfaSelectedMethod === 'Email')">Email</div>
              <div *ngIf="!(isLoading && mfaSelectedMethod === 'Email')">We will send you an email to verify this login.
              </div>
              <div style="padding-left: 47%">
                <mat-spinner *ngIf="isLoading && mfaSelectedMethod === 'Email'" diameter="20"></mat-spinner>
              </div>
            </div>
          </button>
        </div>
        <div *ngIf="hasError">
          <strong style="color: #f44336; font-size: 12px;">Unable to send code. Please contact support for assistance.</strong>
        </div>
      </div>
    </div>
  </div>
</div>